import React from "react";
import BlogsList from "../blogs/Blogs";
const BlogsComponent = () => {
  return (
    <div
      id="blogs"
      className="fade-in flex flex-col items-center justify-center"
    >
      <div className=" justify-items-center mx-4 flex flex-wrap justify-center gap-4">
        {BlogsList.map((project) => (
          <div className="flex flex-col justify-between py-8 px-2 md:px-4 w-[100%] max-h-[550px] md:max-w-[360px] rounded-lg">
            <div>
              <img
                alt={project.title}
                className="block mx-auto mb-4 outline outline-1 rounded-lg outline-neutral-700 w-[100%] md:w-full"
                src={project.img}
              />
              <p className="">{project.title}</p>
            </div>
            <a
              target="_blank"
              className="block text-neutral-400 hover:text-white text-sm transition-all duration-300 py-2 flex items-center gap-2 hover:gap-3"
              href={project.href}
              rel="noreferrer"
            >
              Blog Link
              <i class="fa-solid fa-arrow-right"></i>
            </a>
          </div>
        ))}
      </div>
    </div>
  );
};

export default BlogsComponent;
